import * as React from 'react'
import { FormattedHTMLMessage } from 'react-intl'

import styles from './intro.module.scss'
import Video from '../video'

const Intro = () => (
  <div className={styles.root}>
    <div className={styles.outer}>
      <div className={styles.inner}>
        <div className={styles.heading}>
          <FormattedHTMLMessage defaultMessage="Klick, BankID, klart!" id="diy-accounting.intro.heading" tagName="h2" />
        </div>
        <div className={styles.description}>
          <FormattedHTMLMessage
            defaultMessage="Med smarta integrationer till Skatteverket och bank synkas betalningar automatiskt och du sköter det mesta med ett par klick. It’s bokföring reinvented."
            id="diy-accounting.intro.lede"
            tagName="p"
          />
        </div>
        <Video />
      </div>
    </div>
  </div>
)

export default Intro
